import { render, staticRenderFns } from "./UploadedFileProjectsCell.vue?vue&type=template&id=e5950bc8&scoped=true"
import script from "./UploadedFileProjectsCell.vue?vue&type=script&lang=js"
export * from "./UploadedFileProjectsCell.vue?vue&type=script&lang=js"
import style0 from "./UploadedFileProjectsCell.vue?vue&type=style&index=0&id=e5950bc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5950bc8",
  null
  
)

export default component.exports